import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _get from "@babel/runtime/helpers/get";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import e from "../utils/classSet";
import t from "../utils/hasClass";
import n from "./Framework";

var l = /*#__PURE__*/function (_n) {
  _inherits(l, _n);

  var _super = _createSuper(l);

  function l(e) {
    var _this;

    _classCallCheck(this, l);

    _this = _super.call(this, Object.assign({}, {
      eleInvalidClass: "is-invalid",
      eleValidClass: "is-valid",
      formClass: "fv-plugins-bootstrap5",
      rowInvalidClass: "fv-plugins-bootstrap5-row-invalid",
      rowPattern: /^(.*)(col|offset)(-(sm|md|lg|xl))*-[0-9]+(.*)$/,
      rowSelector: ".row",
      rowValidClass: "fv-plugins-bootstrap5-row-valid"
    }, e));
    _this.eleValidatedHandler = _this.handleElementValidated.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(l, [{
    key: "install",
    value: function install() {
      _get(_getPrototypeOf(l.prototype), "install", this).call(this);

      this.core.on("core.element.validated", this.eleValidatedHandler);
    }
  }, {
    key: "uninstall",
    value: function uninstall() {
      _get(_getPrototypeOf(l.prototype), "install", this).call(this);

      this.core.off("core.element.validated", this.eleValidatedHandler);
    }
  }, {
    key: "handleElementValidated",
    value: function handleElementValidated(n) {
      var _l = n.element.getAttribute("type");

      if (("checkbox" === _l || "radio" === _l) && n.elements.length > 1 && t(n.element, "form-check-input")) {
        var _l5 = n.element.parentElement;

        if (t(_l5, "form-check") && t(_l5, "form-check-inline")) {
          e(_l5, {
            "is-invalid": !n.valid,
            "is-valid": n.valid
          });
        }
      }
    }
  }, {
    key: "onIconPlaced",
    value: function onIconPlaced(n) {
      e(n.element, {
        "fv-plugins-icon-input": true
      });
      var _l3 = n.element.parentElement;

      if (t(_l3, "input-group")) {
        _l3.parentElement.insertBefore(n.iconElement, _l3.nextSibling);

        if (n.element.nextElementSibling && t(n.element.nextElementSibling, "input-group-text")) {
          e(n.iconElement, {
            "fv-plugins-icon-input-group": true
          });
        }
      }

      var i = n.element.getAttribute("type");

      if ("checkbox" === i || "radio" === i) {
        var _i = _l3.parentElement;

        if (t(_l3, "form-check")) {
          e(n.iconElement, {
            "fv-plugins-icon-check": true
          });

          _l3.parentElement.insertBefore(n.iconElement, _l3.nextSibling);
        } else if (t(_l3.parentElement, "form-check")) {
          e(n.iconElement, {
            "fv-plugins-icon-check": true
          });

          _i.parentElement.insertBefore(n.iconElement, _i.nextSibling);
        }
      }
    }
  }, {
    key: "onMessagePlaced",
    value: function onMessagePlaced(n) {
      n.messageElement.classList.add("invalid-feedback");
      var _l4 = n.element.parentElement;

      if (t(_l4, "input-group")) {
        _l4.appendChild(n.messageElement);

        e(_l4, {
          "has-validation": true
        });
        return;
      }

      var i = n.element.getAttribute("type");

      if (("checkbox" === i || "radio" === i) && t(n.element, "form-check-input") && t(_l4, "form-check") && !t(_l4, "form-check-inline")) {
        n.elements[n.elements.length - 1].parentElement.appendChild(n.messageElement);
      }
    }
  }]);

  return l;
}(n);

export { l as default };